import _ from 'lodash';
import qs from 'qs';
import { axiosAPI } from '@/axios';

const defaultFilter = { status: 'any', sort: 'createdAt' };

const loadCollections = (filter) => {
  const query = qs.stringify(_.defaults(filter, defaultFilter), { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/collections${query}`);
  }
  return axiosAPI.get('/collections');
};

const loadCollectionById = (collectionId) => {
  return axiosAPI.get(`/collections/${collectionId}?showEditor=any`);
};

const createCollection = (collection) => {
  return axiosAPI.post('/collections', collection);
};

const updateCollection = (collectionId, collection) => {
  return axiosAPI.put(`/collections/${collectionId}`, collection);
};

const deleteCollection = (collectionId) => {
  return axiosAPI.delete(`/collections/${collectionId}`);
};

const loadCollectionItemsbyId = (filter, collectionId) => {
  const query = qs.stringify(filter, {
    addQueryPrefix: true,
    skipNulls: true,
    arrayFormat: 'comma',
    encode: false,
  });
  if (query) {
    return axiosAPI.get(`/collections/${collectionId}/collection-items${query}`);
  }
  return axiosAPI.get(`/collections/${collectionId}/collection-items`);
};

const addItemCollection = (collectionId, itemId) => {
  return axiosAPI.post(`collections/${collectionId}/collection-items`, itemId);
};

const checkExistingItemCollection = (itemId) => {
  return axiosAPI.get(`collections/items/${itemId}`);
};

const deleteExistingItemCollection = (collectionId, itemId) => {
  return axiosAPI.delete(`collections/${collectionId}/collection-items/${itemId}`);
};

const getCollectionPreview = (filter, collectionId) => {
  const query = qs.stringify(filter, {
    addQueryPrefix: true,
    skipNulls: true,
    arrayFormat: 'comma',
    encode: false,
  });
  return axiosAPI.get(`collections/${collectionId}/preview${query}`);
};

export {
  loadCollections,
  loadCollectionById,
  createCollection,
  updateCollection,
  deleteCollection,
  addItemCollection,
  loadCollectionItemsbyId,
  checkExistingItemCollection,
  deleteExistingItemCollection,
  getCollectionPreview,
};
